import conditionalQuestions from "./Conditionals";
import discourseConnectorsQuestions from "./DiscourseConnectors";
import futureTenseQuestions from "./FutureTense";
import idiomaticExpressionsQuestions from "./IdiomaticExpressions";
import imperativeQuestions from "./Imperative";
import pastTenseQuestions from "./PastTense";
import porParaQuestions from "./PorVsPara";
import prepositionQuestions from "./Prepositions";
import presentAndPresentPerfectQuestions from "./PresentTense";
import pronunciationAndToneQuestions from "./Pronounciation";
import pronounQuestions from "./Pronouns";
import reflexiveVerbsQuestions from "./Reflexives";
import serEstarQuestions from "./SerVsEstar";
import subjunctiveQuestions from "./Subjunctive";
import activePasiveVoiceQuestions from "./Voices";

const quizQuestions = [
    ...serEstarQuestions,
    ...porParaQuestions,
    ...pastTenseQuestions,
    ...conditionalQuestions,
    ...imperativeQuestions,
    ...subjunctiveQuestions,
    ...prepositionQuestions,
    ...pronunciationAndToneQuestions,
    ...futureTenseQuestions,
    ...idiomaticExpressionsQuestions,
    ...discourseConnectorsQuestions,
    ...presentAndPresentPerfectQuestions,
    ...reflexiveVerbsQuestions,
    ...activePasiveVoiceQuestions,
    ...pronounQuestions
];

export default quizQuestions;
